"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var results_exports = {};
__export(results_exports, {
  ResultArray: () => ResultArray
});
module.exports = __toCommonJS(results_exports);
var import_core = require("@hcengineering/core");
class ResultArray {
  constructor(docs, hierarchy) {
    this.hierarchy = hierarchy;
    this.docs = new Map(docs.map((it) => [it._id, it]));
    for (const doc of docs) {
      this.loadedModifiedOn.set(doc._id, doc.modifiedOn);
    }
  }
  static {
    __name(this, "ResultArray");
  }
  docs;
  loadedModifiedOn = /* @__PURE__ */ new Map();
  // An equal-timestamp $inc is applied locally, so a re-delivered tx would increment twice.
  // Ids are kept only for the doc's current timestamp, which only moves forward.
  appliedInc = /* @__PURE__ */ new Map();
  clones = /* @__PURE__ */ new Map();
  get length() {
    return this.docs.size;
  }
  isLoadedAtModifiedOn(_id, modifiedOn) {
    return this.loadedModifiedOn.get(_id) === modifiedOn;
  }
  setLoadedModifiedOn(_id, modifiedOn) {
    this.loadedModifiedOn.set(_id, modifiedOn);
  }
  clearLoadedModifiedOn(_id) {
    this.loadedModifiedOn.delete(_id);
  }
  isIncApplied(_id, txId, modifiedOn) {
    const applied = this.appliedInc.get(_id);
    return applied?.ts === modifiedOn && applied.ids.has(txId);
  }
  markIncApplied(_id, txId, modifiedOn) {
    const applied = this.appliedInc.get(_id);
    if (applied?.ts === modifiedOn) {
      applied.ids.add(txId);
    } else {
      this.appliedInc.set(_id, { ts: modifiedOn, ids: /* @__PURE__ */ new Set([txId]) });
    }
  }
  clean() {
    this.clones.clear();
  }
  getDocs() {
    return Array.from(this.docs.values());
  }
  findDoc(_id) {
    return this.docs.get(_id);
  }
  getClone() {
    return this.hierarchy.clone(this.getDocs());
  }
  getResult(id) {
    const info = this.clones.get(id);
    if (info === void 0) {
      const docs = this.getClone();
      this.clones.set(id, new Map(docs.map((it) => [it._id, it])));
      return docs;
    } else {
      return Array.from(info.values());
    }
  }
  delete(_id) {
    this.loadedModifiedOn.delete(_id);
    this.appliedInc.delete(_id);
    const doc = this.docs.get(_id);
    this.docs.delete(_id);
    for (const [, v] of this.clones.entries()) {
      v.delete(_id);
    }
    return doc;
  }
  // Both return the object actually stored, which is a clone of the argument unless told
  // otherwise: Refs has to point at that one, or later in-place updates pass it by.
  updateDoc(doc, mainClone = true) {
    const stored = mainClone ? this.hierarchy.clone(doc) : doc;
    this.docs.set(doc._id, stored);
    for (const [, v] of this.clones.entries()) {
      v.set(doc._id, this.hierarchy.clone(doc));
    }
    return stored;
  }
  push(doc) {
    const stored = this.hierarchy.clone(doc);
    this.docs.set(doc._id, stored);
    for (const [, v] of this.clones.entries()) {
      v.set(doc._id, this.hierarchy.clone(doc));
    }
    return stored;
  }
  pop() {
    const lastElement = Array.from(this.docs)[this.docs.size - 1];
    if (lastElement !== void 0) {
      this.docs.delete(lastElement[0]);
      for (const [, v] of this.clones.entries()) {
        v.delete(lastElement[0]);
      }
      return lastElement[1];
    }
    return void 0;
  }
  sort(_class, sort, hierarchy, memdb) {
    const docs = Array.from(this.docs.values());
    (0, import_core.resultSort)(docs, sort, _class, hierarchy, memdb);
    this.docs = new Map(docs.map((it) => [it._id, it]));
    for (const [k, v] of this.clones.entries()) {
      this.clones.set(k, new Map(docs.map((it) => [it._id, v.get(it._id) ?? this.hierarchy.clone(it)])));
    }
  }
}
//# sourceMappingURL=results.js.map
